



















































import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SolicitacaoStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoStore'

@Component

export default class ComponentModalSolicitacaoCirurgiaSair extends Vue {
  get getSolicitacaoStore() {
    return getModule(SolicitacaoStore, this.$store)
  }

  closeModalSair() {
    return this.getSolicitacaoStore.setShowModalSair(false)
  }

  get showModalSair() {
    return this.getSolicitacaoStore.modalSolicitacaoCirurgia.showSair
  }

  sair() {
    this.getSolicitacaoStore.clearSolicitacao()
    this.getSolicitacaoStore.setShowModalSair(false)
    this.$router.push('/agendamento-medico')
  }
}
